module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/babel-runtime/core-js/json/stringify.js
 ** module id = 59
 ** module chunks = 2
 **/